import React, { useEffect, useState } from "react";
import axios from "axios";
import BannerFormModal from "./BannerFormModal";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import { Icon } from "organisms/iconCommonent";
import { MdDelete } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

interface Banner {
  _id: string;
  bannerImage: string;
  heading: string;
  description: string;
}

export default function BannerDashboard() {
  const [banner, setBanner] = useState<Banner | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [editingBanner, setEditingBanner] = useState<Banner | null>(null);

  const fetchBanners = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_LOCAL_URL}/api/banner-data`);
      const selectedBanner = res.data.data[0];
      setBanner(selectedBanner);
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const handleEdit = (banner: Banner) => {
    setEditingBanner(banner);
    setShowForm(true);
  };

  return (
    <div className="pt-8">
      <div className="flex justify-between items-center mb-6">
        <h2 className="font-lato-regular">Section - 01</h2>
    
      </div>

   

      {/* Banner Box */}
      {banner && (
        <div className="width-[18rem] mx-auto bg-white border border-gray-200 rounded-xl  overflow-hidden ">
          <img
            src={`${process.env.REACT_APP_LOCAL_URL}/${banner.bannerImage}`}
            alt={banner.heading}
            className="w-full h-[18rem] object-cover"
          />
          <div className="p-5">
            <h2 className="text-xl font-semibold  text-black font-lato-regular mb-2">
              {banner.heading}
            </h2>
            <h6 className=" text-md text-black font-lato-regular mb-4">
              {banner.description}
            </h6>

            <div className="flex justify-start gap-3">
              <button
                className="bg-blue-500 font-lato-regular text-white px-4 py-2 rounded"
                onClick={() => handleEdit(banner)}
              >
                <span className="inline-block mr-1">
                  <Icon icon={FaRegEdit} />
                </span>{" "}
                Edit
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Form Modal */}
      {showForm && (
        <BannerFormModal
          onClose={() => setShowForm(false)}
          fetchBanners={fetchBanners}
          editingBanner={editingBanner}
        />
      )}
    </div>
  );
}
